/**
 *
 * list actions
 *
 */

import {
    LOAD_LIST,
    LOAD_LIST_SUCCESS,
    LOAD_LIST_ERROR,
    CLEAR_LIST_DATA
} from './list-constants';

/**
 * Load the list data, this action starts the request saga
 *
 * @param  {string} topicId  The list topic unique identifier
 * @param  {string} advancedCriteria  The list's advanced criteria
 *
 * @return {object}     An action object with a type of LOAD_LIST
 */
export const loadList = (topicId, advancedCriteria) => ({
    type: LOAD_LIST,
    topicId,
    advancedCriteria,
});

/**
 * Dispatched when the list data payload is loaded
 *
 * @param  {object} data    The list data
 *
 * @return {object}         An action object with a type of LOAD_LIST_SUCCESS passing the list data
 */
export const listLoaded = (data) => ({
    type: LOAD_LIST_SUCCESS,
    data,
});

/**
 * Dispatched when loading the list data fails
 *
 * @param  {object} error   The error
 *
 * @return {object}         An action object with a type of LOAD_LIST_ERROR passing the error
 */
export const listLoadingError = (error) => ({
    type: LOAD_LIST_ERROR,
    error,
});

/**
 * Clears all the list state from the store
 *
 *
 * @return {object}         An action object with a type of CLEAR_LIST_DATA
 */
export const clearListData = () => ({
    type: CLEAR_LIST_DATA,
});
